import { useEffect, useState } from "react";
import { PortableText } from "@portabletext/react";

const Intro = (props) => {
  const { sanityData } = props;
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    setPhase(1);
    setTimeout(() => {
      setPhase(2);
      setTimeout(() => {
        // const interval = setInterval(() => {
        //   if (sanityData.intro && sanityData.intro.names !== "") {
        //     clearInterval(interval);
        //     console.log("yep");

            setPhase(3);
            setTimeout(() => {
              const names = document.getElementById("introNames");
              const height = names.offsetHeight;
              names.style.top = `calc(-${height}px + (var(--app-height) / 2) + 4vw)`;
              setTimeout(() => {
                setPhase(5);
              }, 3000);
              setPhase(4);
            }, 400);
          // } else {
          //   return;
          // }
        // }, 10);
      }, 400);
    }, 400);
  }, []);

  return (
    <div className={`intro__wrapper ${phase >= 5 ? "disabled" : ""}`}>
      <div
        className={`intro__logos-wrapper ${phase >= 3 ? "active" : ""} ${
          phase >= 3 ? "rotate" : ""
        }`}
      >
        <div className={`intro__logo-left`}>
          <img
            className={`intro__ra ${phase >= 2 ? "active" : ""}`}
            src="./assets/RA.svg"
            alt="RESIDENT ADVISOR"
          />
        </div>
        <div
          className={`intro__line ${phase >= 1 ? "height" : ""} ${
            phase >= 2 ? "rotate" : ""
          }`}
        ></div>
        <div className={`intro__logo-right `}>
          <div className={`intro__1000 ${phase >= 2 ? "active" : ""}`}>
            1000
          </div>
        </div>
      </div>

      <div className={`intro__names-wrapper`} id="introNames">
        {/* {sanityData.intro ? (
          <>
            <div className="intro__names">
              <PortableText value={sanityData.intro.names} />
            </div>
            <div className="intro__numbers">
              <PortableText value={sanityData.intro.numbers} />
            </div>
          </>
        ) : (
          ""
        )} */}
        <div className={`intro__names`}>
          Troy Pierce
          <br />
          Pig & Dan
          <br />
          Jay Haze
          <br />
          Dygas
          <br />
          Kiki
          <br />
          Matt Tolfrey
          <br />
          Bill Patrick
          <br />
          Dan Ghenacia
          <br />
          Oliver Hacke
          <br />
          Serge Santiago
          <br />
          Digitalism
          <br />
          Dominik Eulberg
          <br />
          Scarlette Ettiene
          <br />
          Headman
          <br />
          Patrick Chardronnet
          <br />
          Chris De Luca
          <br />
          Matthew Styles
          <br />
          Andrew Grant
          <br />
          Will Saul
          <br />
          Mike Shannon
          <br />
          Maurice Fulton
          <br />
          Dennis Rodgers
          <br />
          Transparent Sound
          <br />
          Butane
          <br />
          Italoboyz
          <br />
          Cassy
          <br />
          Ewan Pearson
          <br />
          Arnaud Rebotini
          <br />
          Rob Mello
          <br />
          Adam Beyer
          <br />
          Jamie Jones
          <br />
          Henrik Schwarz
          <br />
          Geddes
          <br />
          MyMy
          <br />
          Heidi
          <br />
          Slam
          <br />
          Oliver Huntemann
          <br />
          Stacey Pullen
          <br />
          Ryan Elliott
          <br />
          M.A.N.D.Y
          <br />
          Exercise One
          <br />
          Âme
          <br />
          Stephan Bodzin
          <br />
          Château Flight
          <br />
          Joakim
          <br />
          Tim Sweeney
          <br />
          Vince Watson
          <br />
          Dixon
          <br />
          Alex Smoke
          <br />
          Ripperton
          <br />
          Redshape
          <br />
          Alexander Robotnick
          <br />
          Riton
          <br />
          Simon Baker
          <br />
          Sebo K<br />
          Stefan Goldmann
          <br />
          Efdemin
          <br />
          Guy Gerber
          <br />
          Jeremy P Caulfield
          <br />
          Future Loop Foundation
          <br />
          Radioclit
          <br />
          Joris Voorn
          <br />
          Ben Klock
          <br />
          Samim
          <br />
          Hector
          <br />
          Ron Trent
          <br />
          Anja Schneider
          <br />
          Dan Curtain
          <br />
          Swayzak
          <br />
          Prosumer
          <br />
          Crowdpleaser
          <br />
          Deadbeat
          <br />
          Chloé
          <br />
          Prins Thomas
          <br />
          Sven Weisemann
          <br />
          Michael Fakesch
          <br />
          Deadset
          <br />
          Tyger Dhula
          <br />
          Brendon Moeller
          <br />
          Underworld
          <br />
          Mike Vamp
          <br />
          Goon & Koyote
          <br />
          Gregor Tresher
          <br />
          Trickski
          <br />
          Tobias Freund
          <br />
          Juan Maclean
          <br />
          JD Twitch (Optimo)
          <br />
          Andy Stott & Claro Intelecto
          <br />
          Kalabrese
          <br />
          Sasse
          <br />
          Pole
          <br />
          Derek Plaslaiko
          <br />
          Mara Trax
          <br />
          Anders Ilar
          <br />
          Kevin Saunderson
          <br />
          Dinky
          <br />
          Sascha Dive
          <br />
          Todd Terje
          <br />
          The Count & Sinden
          <br />
          Richie Hawtin
          <br />
          Falko Brocksieper
          <br />
          Four Tet
          <br />
          Alex Flitsch
          <br />
          Quiet Village
          <br />
          Donato Dozzy
          <br />
          Nôze
          <br />
          Laurent Garnier
          <br />
          Triple R<br />
          The Mole
          <br />
          Appleblim
          <br />
          Stimming
          <br />
          Mark E<br />
          Pigon
          <br />
          Aeroplane
          <br />
          Patrice Bäumel
          <br />
          Gerd Janson
          <br />
          Portable / Bodycode
          <br />
          Heartbreak
          <br />
          Greg Wilson
          <br />
          Steffi
          <br />
          Lee Jones
          <br />
          Simbad
          <br />
          The Black Dog
          <br />
          Derrick Carter
          <br />
          Move D<br />
          Motorcitysoul
          <br />
          Jus-Ed
          <br />
          Murmur
          <br />
          Lee Burridge
          <br />
          Emerson Todd
          <br />
          Johnno Burgess
          <br />
          Motor City Drum Ensemble
          <br />
          Trus'me
          <br />
          Danny Howells
          <br />
          Marcel Dettmann
          <br />
          The Orb
          <br />
          Sebastien San
          <br />
          René Breitbarth
          <br />
          Disco Bloodbath
          <br />
          Pivot
          <br />
          Marco Passarani
          <br />
          Josh Wink
          <br />
          Thomas Brinkmann
          <br />
          Surgeon
          <br />
          DJ Koze
          <br />
          Culoe De Song
          <br />
          DJ Pete
          <br />
          Linkwood and House of Traps
          <br />
          Losoul
          <br />
          Booka Shade
          <br />
          Bill Brewster
          <br />
          Ellen Allien
          <br />
          Intrusion
          <br />
          Moonstarrr
          <br />
          Louderbach
          <br />
          Seth Troxler
          <br />
          Tony Lionni
          <br />
          Levon Vincent
          <br />
          Manuel Tur
          <br />
          Giles Smith
          <br />
          Lawrence
          <br />
          nsi.
          <br />
          Pisco Sour
          <br />
          Maayan Nidam
          <br />
          Drums Of Death
          <br />
          The Revenge
          <br />
          Matias Aguayo
          <br />
          Peter Van Hoesen
          <br />
          Frankie Knuckles
          <br />
          FaltyDL
          <br />
          Erol Alkan
          <br />
          Still Going
          <br />
          Modeselektor
          <br />
          Neil Landstrumm
          <br />
          Rick Wilhite
          <br />
          Arto Mwambe
          <br />
          Sandwell District
          <br />
          Fever Ray
          <br />
          Joe Goddard
          <br />
          Dor
          <br />
          Simon Caldwell
          <br />
          Matt Edwards (Part I & II)
          <br />
          Jan Krueger
          <br />
          Soulphiction
          <br />
          Guillaume & The Coutu Dumonts
          <br />
          Cosmic Twins
          <br />
          Tensnake
          <br />
          Terre Thaemlitz
          <br />
          Marcus Worgull
          <br />
          DJ Stingray
          <br />
          The Psychonauts
          <br />
          Jacaszek
          <br />
          Petre Inspirescu
          <br />
          Patrick Russell
          <br />
          Thompson
          <br />
          Kuedo
          <br />
          Reboot
          <br />
          Scuba vs SCB
          <br />
          House Of House
          <br />
          Carl Craig
          <br />
          19.454.18.5.25.5.18
          <br />
          Thomas Fehlmann
          <br />
          2562
          <br />
          Starkey
          <br />
          Fudge Fingas
          <br />
          Mike Slott
          <br />
          Rub N Tug
          <br />
          Leonel Castillo
          <br />
          Marcel Fengler
          <br />
          Brothers Bouaziz
          <br />
          Nicolas Jaar
          <br />
          Elektro Guzzi
          <br />
          Fred P<br />
          Tevo Howard
          <br />
          Magda
          <br />
          Mount Kimbie
          <br />
          Jef K<br />
          Peverelist
          <br />
          Cio D'or
          <br />
          Harri + Domenic
          <br />
          Shed
          <br />
          Bruno Pronsato
          <br />
          Superpitcher
          <br />
          Soul Clap
          <br />
          Scott Grooves
          <br />
          Kowton
          <br />
          Detroit Beatdown
          <br />
          Ivan Smagghe
          <br />
          Commix
          <br />
          Alan Howarth
          <br />
          Space Dimension Controller
          <br />
          KiNK
          <br />
          ASC
          <br />
          Terror Danjah
          <br />
          jozif
          <br />
          Petar Dundov
          <br />
          Perc
          <br />
          Ben UFO
          <br />
          Tiger and Woods
          <br />
          Mathew Jonson
          <br />
          Maya Jane Coles
          <br />
          Catz N Dogz
          <br />
          Jonas Kopp
          <br />
          Isolee
          <br />
          Traversable Wormhole
          <br />
          Caribou
          <br />
          Pinch
          <br />
          Danny Tenaglia
          <br />
          Discodeine
          <br />
          Heinrich Mueller
          <br />
          Recloose
          <br />
          Marco Carola
          <br />
          Adam Marshall
          <br />
          Maceo Plex
          <br />
          Lucy
          <br />
          Robag Wruhme
          <br />
          O/V/R
          <br />
          Steve Bug
          <br />
          Skream
          <br />
          Matthew Burton & Kate Rathod
          <br />
          LV
          <br />
          Sei A<br />
          Marcelus
          <br />
          Tobi Neumann
          <br />
          Convextion
          <br />
          Planningtorock
          <br />
          DJ Qu
          <br />
          Ed Davenport
          <br />
          Tornado Wallace
          <br />
          Tokimonsta
          <br />
          Claude VonStroke
          <br />
          Kassem Mosse
          <br />
          Renaissance Man
          <br />
          George Fitzgerald
          <br />
          DJ Deep
          <br />
          Alva Noto
          <br />
          Cosmin TRG
          <br />
          Mike Huckaby
          <br />
          Luca C and Brigante
          <br />
          Martyn
          <br />
          Max Cooper
          <br />
          Giorgio Gigli and Obtane
          <br />
          Tale Of Us
          <br />
          Dexter
          <br />
          Friendly Fires
          <br />
          Xhin
          <br />
          Red D<br />
          Consequence
          <br />
          Jackmaster
          <br />
          Roman Flugel
          <br />
          Lee Foss
          <br />
          TR-101
          <br />
          Nicholas
          <br />
          DJ Nobu
          <br />
          Jay Shepheard
          <br />
          Nina Kraviz
          <br />
          Synkro
          <br />
          Patrice Scott
          <br />
          Agoria
          <br />
          DJ Harvey
          <br />
          Floating Points
          <br />
          Developer
          <br />A Guy Called Gerald
          <br />
          Airhead
          <br />
          Chez Damier
          <br />
          Matthew Dear
          <br />
          DjRUM
          <br />
          Paul Woolford
          <br />
          Svarte Greiner
          <br />
          Shifted
          <br />
          Vakula
          <br />
          Deetron
          <br />
          Ena
          <br />
          Kevin McPhee
          <br />
          Kerri Chandler
          <br />
          Eats Everything
          <br />
          Benoit and Sergio
          <br />
          Rrose
          <br />
          James Zabiela
          <br />
          Shlohmo
          <br />
          Mister Saturday Night
          <br />
          The Sight Below
          <br />
          tINI
          <br />
          Untold
          <br />
          Eli Verveine
          <br />
          Apparat
          <br />
          Vessel
          <br />
          DJ Nature
          <br />
          Gaslamp Killer
          <br />
          Robert Hood
          <br />
          Joy Orbison
          <br />A Sagittariun
          <br />
          Pangaea
          <br />
          Danny Daze
          <br />
          Michael Mayer
          <br />
          Dusk and Blackdown
          <br />
          Phase
          <br />
          Apollonia
          <br />
          October
          <br />
          Art Department
          <br />
          Auntie Flo
          <br />
          Matthew Dekay
          <br />
          Ron Morelli
          <br />
          Mano Le Tough
          <br />
          Answer Code Request
          <br />
          Jerome Sydenham
          <br />
          Subb-an
          <br />
          Zenker Brothers
          <br />
          Samuel Kerridge
          <br />
          PillowTalk
          <br />
          Truss / MPIA3
          <br />
          Ital Tek
          <br />
          Dense & Pika
          <br />
          Merveille & Crosson
          <br />
          Jam City
          <br />
          Dadub
          <br />
          John Swing
          <br />
          D-Bridge
          <br />
          The Haxan Cloak
          <br />
          Solomun
          <br />
          Pearson Sound
          <br />
          Kyle Hall
          <br />
          Marcellis
          <br />
          Skudge
          <br />
          FunkinEven
          <br />
          John Roberts
          <br />
          James Holden
          <br />
          Luke Hess
          <br />
          Sven Vath
          <br />
          Archie Pelago
          <br />
          Black Coffee
          <br />
          Akkord
          <br />
          Helena Hauff
          <br />
          Outboxx
          <br />
          Blondes
          <br />
          Oneman
          <br />
          Dennis Ferrer
          <br />
          Anton Zap
          <br />
          Juju and Jordash
          <br />
          Joey Anderson
          <br />
          Mark Fell
          <br />
          Spencer Parker
          <br />
          Trentemoller
          <br />
          FCL
          <br />
          Daniel Avery
          <br />
          Machinedrum
          <br />
          Traumprinz
          <br />
          Fis
          <br />
          L.B. Dub Corp vs P.A.S.
          <br />
          Deepchord
          <br />
          Bok Bok
          <br />
          Conforce
          <br />
          Om Unit
          <br />
          Leif
          <br />
          Anthony Parasole
          <br />
          Midland
          <br />
          Rene Hell
          <br />
          AnD
          <br />
          STL
          <br />
          Kode9
          <br />
          Jimmy Edgar
          <br />
          Acid Arab
          <br />
          Kris Wadsworth
          <br />
          Evian Christ
          <br />
          Galcher Lustwerk
          <br />
          DJ Marfox
          <br />
          Beneath
          <br />
          Mo Kolours
          <br />
          Legowelt
          <br />
          Rivet
          <br />
          Awanto 3<br />
          Dana Ruh
          <br />
          Francois X<br />
          ItaloJohnson
          <br />
          Ron Hardy
          <br />
          Sandrien
          <br />
          Downliners Sekt
          <br />
          Rodhad
          <br />
          Traxman
          <br />
          Lone
          <br />
          Lena Willikens
          <br />
          Abdulla Rashim
          <br />
          Dusky
          <br />
          DJ Dodger Stadium
          <br />
          South London Ordnance
          <br />
          Oliver Hafenbauer
          <br />
          Luke Abbott
          <br />
          Steve Rachmad vs STERAC
          <br />
          Moire
          <br />
          Shxcxchcxsh
          <br />
          Shanti Celeste
          <br />
          Lunice
          <br />
          Lee Gamble
          <br />
          Ben Aqua
          <br />
          Call Super
          <br />
          Slackk
          <br />
          Dave Clarke
          <br />
          Aquarian
          <br />
          Lowtec
          <br />
          Dj Spoko
          <br />
          Marco Shuttle
          <br />
          Tin Man
          <br />
          Graze
          <br />
          Dorian Concept
          <br />
          Phil Moffa
          <br />
          Frank & Tony
          <br />
          Barnt
          <br />
          DJ Taye
          <br />
          Bvdub
          <br />
          Pender Street Steppers
          <br />
          Mr G<br />
          DJ Bone vs Differ-Ent
          <br />
          Suzanne Kraft
          <br />
          DJ Masda
          <br />
          Anthony Naples
          <br />
          Logos
          <br />
          Sleeparchive
          <br />
          Edward
          <br />
          Solar
          <br />
          Rabih Beaini
          <br />
          Tama Sumo
          <br />
          Job Jobse
          <br />
          Nick Hoppner
          <br />
          Paula Temple
          <br />
          Aquaplano
          <br />
          Bjorn Torske
          <br />
          Vril
          <br />
          I-F
          <br />
          Dasha Rush
          <br />
          Andrew Weatherall
          <br />
          Lot.te
          <br />
          Lakker
          <br />
          Nicolas Lutz
          <br />
          Carlos Souffront
          <br />
          Blanck Mass
          <br />
          Glenn Astro
          <br />
          Jane Fitz
          <br />
          Daniele Baldelli
          <br />
          Cassegrain
          <br />
          Michael Gracioppo
          <br />
          Jasper James
          <br />
          Mind Against
          <br />
          Sassy J<br />
          Bjarki
          <br />
          DJ Firmeza
          <br />
          DJ Richard
          <br />
          Lo Shea
          <br />
          Visionist
          <br />
          Basic Soul Unit
          <br />
          Florian Kupfer
          <br />
          Sasha
          <br />
          Benjamin Damage
          <br />
          Herodot
          <br />
          Tiga
          <br />
          Youngsta
          <br />
          Len Faki
          <br />
          Eclair Fifi
          <br />
          Ben Sims
          <br />
          DJ Paypal
          <br />
          Omar S<br />
          Porn Sword Tobacco
          <br />
          Eric Cloutier
          <br />
          Andy Hart
          <br />
          Gunnar Haslam
          <br />
          Josey Rebelle
          <br />
          Sunil Sharpe
          <br />
          Sadar Bahar
          <br />
          Bill Converse
          <br />
          Ruby My Dear
          <br />
          DJ Deeon
          <br />
          Soichi Terada
          <br />
          Hops
          <br />
          Markus Suckut
          <br />
          Leafar Legov
          <br />
          Keita Sano
          <br />
          Oskar Offermann <br />
          Awesome Tapes From Africa
          <br />
          Francesco Del Garda
          <br />
          Kangding Ray
          <br />
          Sonja Moonear
          <br />
          The Range
          <br />
          Dolan Bergin
          <br />
          Tessela
          <br />
          Boys Noize
          <br />
          Dr.Rubinstein
          <br />
          Karenn
          <br />
          Red Greg
          <br />
          Raime
          <br />
          Lazare Hoche
          <br />
          MCDE vs Underground
          <br />
          Evan Baggs
          <br />
          Marquis Hawkes
          <br />
          Tijana T<br />
          Mix Mup
          <br />
          Kornél Kovács
          <br />
          The Exaltics
          <br />
          James Ruskin
          <br />
          DJ Spider
          <br />
          rRoxymore
          <br />
          Zaltan
          <br />
          Henrik Bergqvist
          <br />
          Beautiful Swimmers
          <br />
          Loxy
          <br />
          Telephones
          <br />
          ZIÚR
          <br />
          Esther Duijn
          <br />
          RVDS
          <br />
          John FM
          <br />
          Volvox
          <br />
          Aybee
          <br />
          Black Motion
          <br />
          Tuff City Kids
          <br />
          Mark Barrott
          <br />
          Craig Richards
          <br />
          Moscoman
          <br />
          Varg
          <br />
          Inga Mauer
          <br />
          Egyptrixx
          <br />
          Vladimir Ivkovic
          <br />
          Visible Cloaks <br />
          Kingdom
          <br />
          Nathan Fake
          <br />
          Joseph Capriati
          <br />
          Kablam
          <br />
          Lutto Lento
          <br />
          Sisi
          <br />
          Pablo Mateo
          <br />
          Svreca <br />
          Willow
          <br />
          Wolfgang Voigt
          <br />
          Young Marco
          <br />
          Haruka
          <br />
          DJ Koolt
          <br />
          Flørist
          <br />
          SIT
          <br />
          Mr Mendel
          <br />
          Saoirse
          <br />
          Mark Broom
          <br />
          Courtesy
          <br />
          Rahaan
          <br />
          Hodge <br />
          Steve Bicknell
          <br />
          CC:Disco
          <br />
          Galaxian
          <br />
          Francis Inferno Orchestra
          <br />
          Zadig
          <br />
          Baba Stiltz
          <br />
          Jamie Tiller
          <br />
          Erika <br />
          Jon K<br />
          Noncompliant
          <br />
          DJ Minx
          <br />
          Phase Fatale
          <br />
          Nick The Record
          <br />
          M.E.S.H.
          <br />
          Oscar Mulero <br />
          Mafalda
          <br />
          Anastasia Kristensen
          <br />
          Partok
          <br />
          The Black Madonna
          <br />
          Neel
          <br />
          Etienne
          <br />
          Lakuti
          <br />
          Eris Drew
          <br />
          Chris SSG
          <br />
          Scott Zacharias
          <br />
          Peggy Gou
          <br />
          Dona aka DJ Plant Texture
          <br />
          Fantastic Man
          <br />
          DJ Bus Replacement Service
          <br />
          DJ Spinna
          <br />
          The Outside Agency
          <br />
          East Man
          <br />
          Sync 24
          <br />
          SHYBOI
          <br />
          Mall Grab
          <br />
          Wata Igarashi
          <br />
          John Dimas
          <br />
          Gwenan
          <br />
          dgoHn <br />
          Grouper
          <br />
          Alienata
          <br />
          Underground Resistance
          <br />
          Charlotte De Witte
          <br />
          Alexander Nut <br />
          Zozo
          <br />
          Traxx
          <br />
          Parris
          <br />
          Amelie Lens
          <br />
          Yoshinori Hayashi
          <br />
          Buttechno
          <br />
          Raphael Top Secret
          <br />
          Julianna
          <br />
          Acronym
          <br />
          TC80
          <br />
          John Gomez
          <br />
          Tommy Four Seven
          <br />
          Nightwave
          <br />
          Paquita Gordon
          <br />
          Esteban Adame
          <br />
          Freddy K<br />
          Moxie
          <br />
          The Hacker
          <br />
          Leon Vynehall
          <br />
          Ancient Methods
          <br />
          Lil Mofo
          <br />
          Roi Perez
          <br />
          Sarah Davachi
          <br />
          Orpheu The Wizard
          <br />
          Objekt
          <br />
          Bruce
          <br />
          Ectomorph
          <br />
          Arp
          <br />
          Lux
          <br />
          Mama Snake
          <br />
          Nathan Micay
          <br />
          Honey Dijon
          <br />
          Huerco S<br />
          Nazira
          <br />
          Nkisi
          <br />
          Fit Siegel
          <br />
          Olof Dreijer
          <br />
          Veronica Vasicka
          <br />
          Turtle Bugg
          <br />
          LNS
          <br />
          Matrixxman
          <br />D Tiffany
          <br />
          Exos
          <br />
          Peder Mannerfelt
          <br />
          Yu Su
          <br />
          Verraco
          <br />
          Adi Toohey
          <br />
          Boris
          <br />
          Jonny Nash
          <br />
          Héctor Oaks
          <br />
          Croatian Amor
          <br />
          DEBONAIR
          <br />
          Massimiliano Pagliara
          <br />
          DJ Marcelle
          <br />
          Sote
          <br />
          Aurora Halal
          <br />
          Savile
          <br />
          Phuong Dan
          <br />
          Deena Abdelwahed
          <br />
          Cooper Saver
          <br />
          Russell E.L. Butler
          <br />
          Autechre
          <br />
          Ash Lauryn
          <br />
          sold
          <br />
          Millos Kaiser
          <br />
          Truly Madly
          <br />
          Cashu
          <br />
          Kr!z
          <br />
          DJ Haram
          <br />
          Nicole Misha
          <br />
          Titonton Duvante
          <br />
          SO
          <br />
          Shapednoise
          <br />
          Aisha Devi
          <br />
          Powder
          <br />
          Pandora's Jukebox
          <br />
          Or:la
          <br />
          B.Traits
          <br />
          Esa
          <br />
          India Jordan
          <br />
          Beatrice Dillon
          <br />
          Changsie <br />
          Kampire
          <br />
          Schacke
          <br />
          Nadia Khan
          <br />
          The Carry Nation <br />
          Analog Soul
          <br />
          Rosa Pistola
          <br />
          Spekki Webu
          <br />
          Monster
          <br />
          Andy Garvey
          <br />
          Stenny
          <br />
          Low Jack
          <br />
          Nigga Fox
          <br />
          Joe
          <br />
          Gene On Earth
          <br />
          VTSS
          <br />
          Paramida
          <br />
          Conducta <br />
          Rupture LDN
          <br />
          NDRX
          <br />
          Samuel Deep
          <br />
          Valesuchi
          <br />
          Slikback
          <br />
          Mike Servito
          <br />
          DJ Tennis
          <br />
          Kush Jones
          <br />
          Laraaji
          <br />
          Osheyack
          <br />
          Clark Price
          <br />
          Powell
          <br />
          DJ Perception
          <br />
          Grant Aaron
          <br />
          Jayda G<br />
          KMRU
          <br />
          Tzusing
          <br />
          Vlada
          <br />
          DJ Holographic
          <br />
          SPFDJ
          <br />
          Sleep D<br />
          Finn
          <br />
          Kabuto
          <br />
          Jamz Supernova
          <br />
          Nazar
          <br />
          Jasmine Infiniti
          <br />
          patten
          <br />
          Melina Serser
          <br />
          Whodat
          <br />
          Ethiopian Records
          <br />
          Z@P
          <br />
          Roza Terenzi <br />
          Tim Reaper
          <br />
          Tailor Jae
          <br />
          Andrew Ashong
          <br />
          Hyph11E
          <br />
          Forest Management
          <br />
          Peach
          <br />
          Off The Meds
          <br />
          Logic1000
          <br />
          Calibre
          <br />
          DJ Q<br />
          Andrea
          <br />
          Carl Cox
          <br />
          Octo Octa
          <br />
          Venetta
          <br />
          Philipp Gorbachev
          <br />
          Space Afrika
          <br />
          Laurine
          <br />
          Channel Tres
          <br />
          Endgame
          <br />
          dreamcastmoe
          <br />
          Flora Yin-Wong
          <br />
          Dengue Dengue Dengue
          <br />
          Scratcha DVA
          <br />
          Alexis
          <br />
          Sam Goku
          <br />
          Jossy Mitsu
          <br />
          Experimental Housewife
          <br />
          Sally C<br />
          Ripatti
          <br />
          MARRØN
          <br />
          DJ IC <br />
          Ehua
          <br />
          Mdou Moctar
          <br />
          Cici
          <br />
          Quartz
          <br />
          Elkka
          <br />
          Kitty Amor <br />
          Mez
          <br />
          Moopie
          <br />
          Darryn Jones & Tone B. Nimble
          <br />
          DJ Pitch
          <br />
          Wanton Witch
          <br />
          DJ Minx
          <br />
          UNiiQU3
          <br />
          Laelo Black
          <br />
          Caltonic SA <br />
          Juliana Huxtible <br />
          Oriana
          <br />
          Grand River
          <br />
          SALOME
          <br />
          Fort Romeau
          <br />
          Chippy Nonstop
          <br />
          Corin
          <br />
          MikeQ <br />
          Sound Metaphors <br />
          Mella Dee
          <br />
          Jyoty
          <br />
          Sky H1 wellness mix
          <br />
          Bradley Zero
          <br />
          OKO DJ
          <br />
          Flava D<br />
          Maher Daniel
          <br />
          DJ Lag
          <br />
          Sunju Hargun
          <br />
          Gigi FM
          <br />
          Clark
          <br />
          Nicolá Cruz
          <br />
          Ahadadream
          <br />
          Physical Therapy
          <br />
          Niks
          <br />
          Louie Vega
          <br />
          HAAi
          <br />
          Roy Davis Jr.
          <br />
          Madam X<br />
          Ciel
          <br />
          Nick León
          <br />
          Emerald
          <br />
          Marco Weibel
          <br />
          Deadbeat & Sa Pa
          <br />
          Gabrielle Kwarteng
          <br />
          OSSX
          <br />
          Eli Escobar
          <br />
          Lady Machine
          <br />
          Kelly Lee Owens
          <br />
          Fadi Mohem
          <br />
          Nosedrip
          <br />
          Tribal Brothers
          <br />
          Nadia Struiwigh
          <br />
          DJ Noir
          <br />
          Bella Boo
          <br />
          Nikki Nair
          <br />
          ¥ØU$UK€ ¥UK1MAT$U
          <br />
          Nene H<br />
          Hamish & Toby
          <br />
          Infinite Division
          <br />
          Tama Sumo & Lakuti x Panorama Bar (RA 21)
          <br />
          Francois K x Deep Space (RA 21)
          <br />
          DJ Nobu x Future Terror (RA 21)
          <br />
          Karizma
          <br />
          Marie Davidson
          <br />
          DJ Voices (RA 21)
          <br />
          Colleen Cosmo Murphy
          <br />
          Kai Campos (Mount Kimbie
          <br />
          Sedef Adasï
          <br />
          Yazzus
          <br />
          Earth Trax
          <br />
          Skee Mask <br />
          Anetha
          <br />
          Dam Swindle
          <br />
          Cardopusher
          <br />
          Femanyst
          <br />
          Avtomat
          <br />
          Jennifer Cardini
          <br />
          Kikelomo
          <br />
          fjaak
          <br />
          Solid Blake
          <br />
          Parrish Smith
          <br />
          ISAbella
          <br />
          Rebolledo
          <br />
          Eddie "Flashin" Fowlkes
          <br />
          Akua
          <br />
          V.I.V.E.K.
          <br />
          Bill Kouligas
          <br />
          Elisa Bee
          <br />
          Otik
          <br />
          Fever Ray
          <br />
          Etapp Kyle
          <br />
          Cormac
          <br />
          Daria Kolosova
          <br />
          Shinedoe
          <br />
          Hieroglyphic Being
          <br />
          DJ Mell G<br />
          Truncate
          <br />
          Jorkes
          <br />
          Lamin Fofana
          <br />
          Andrés
          <br />
          Todd Terry
          <br />
          Ruby Savage
          <br />
          Kerrie
          <br />
          IG Culture
          <br />
          Colored Craig
          <br />
          Stacey Hottwax Hale
          <br />
          Total Freedom
          <br />
          Clarisa Kimskii
          <br />
          Di Linh
          <br />
          Mike Paradinas/Jlin
          <br />
          Diskonnected
          <br />
          Goldie
          <br />
          Azu Tiwaline
          <br />
          AIDA
          <br />
          Facta & K-LONE
          <br />
          Bake
          <br />
          Kasra
          <br />
          Shy One
          <br />
          Florentino
          <br />
          33EMYBW
          <br />
          Delano Smith
          <br />
          Quest
          <br />
          Dr Banana
          <br />
          Purelink
          <br />
          Soul Summit
          <br />
          Ariel Zetina
          <br />
          Client_03
          <br />
          Manuka Honey
          <br />
          Mogwaa
          <br />
          Rick Wade
          <br />
          Bitter Babe
          <br />
          Shubostar
          <br />
          FAUZIA
          <br />
          Sugar Free
          <br />
          MCR-T b2b DJ Gigola
          <br />
          Introspekt
          <br />
          INVT
          <br />
          Setaoc Mass
          <br />
          1morning
          <br />
          Ki/Ki
          <br />
          Simo Cell
          <br />
          T. Williams
          <br />
          Karen Nyame KG
          <br />
          Julia Govor
          <br />
          Actress
          <br />
          BEIGE
          <br />
          Man Power
          <br />
          MUSCLECARS
          <br />
          DJ Flight
          <br />
          Sofia Kourtesis
          <br />
          TSVI
          <br />
          KYRUH
          <br />
          Dar Disku
          <br />
          Lydo
          <br />
          Amor Satyr & Siu Mata
          <br />
          DJ PGZ
          <br />
          Ayanna Heaven
          <br />
          KRN
          <br />
          Two Shell
          <br />
          999999999
          <br />
          Rey Colino
          <br />
          Polygonia
          <br />
          S-candalo
          <br />
          Nídia
          <br />
          Slipmatt
          <br />
          DITA
          <br />
          Funk Assault
          <br />
          Beatrice M.
          <br />
          Joker
          <br />
          Kiernan Laveaux
          <br />
          Fumiya Tanaka
          <br />
          Loidis
          <br />
          Paurro
          <br />
          Konduku
          <br />
          Barry Can't Swim
          <br />
          Lukas Wigflex
          <br />
          upsammy
          <br />
          DJ Maria.
          <br />
          Afriqua
          <br />
          Kia
          <br />
          Black Rave Culture
          <br />
          livwutang
          <br />
          Sansibar
          <br />
          EldiaNYC
          <br />
          Sandwell District
          <br />
          Lyra Pramuk
          <br />
          Phillipa Pacho
          <br />
          Richie Hawtin
          <br />
          Barker
          <br />
          Ayesha
          <br />
          DJ Travella
          <br />
          Lechuga Zafiro
          <br />
          Suze Ijo
          <br />
          Gyrofield
          <br />
          PLO Man
          <br />
          Binh
          <br />
          Bastiengoat
          <br />
          BADSISTA
          <br />
          Laurel Halo
          <br />
          Peshay
          <br />
          D.DAN
          <br />
          DJ TOBZY & Kampire
          <br />
          Ron Trent & Ash Lauryn
          <br />
          Verraco & Bitter Babe
          <br />
          Roza Terenzi & Kim Ann Foxman
          <br />
          1morning & Regal86
          <br />
          Prosumer & Peach
          <br />
          DJ Spinn & DJ Manny
          <br />
          Sonja Moonear & Margaret Dygas
          <br />
          Theo Parrish
          <br />
          Sama' Abdulhadi
          <br />
          Mark Ernestus
          <br />
          Tim Reaper
          <br />
          Terre Thaemlitz
          <br />
          Bicep
          <br />
          Helena Hauff
          <br />
          Jyoty
          <br />
          Frankie Knuckles
          <br />
          DJ Harvey & Andrew Weatherall
        </div>
        <div className={`intro__numbers`}>
          .0001
          <br />
          .0002
          <br />
          .0003
          <br />
          .0004
          <br />
          .0005
          <br />
          .0006
          <br />
          .0007
          <br />
          .0008
          <br />
          .0009
          <br />
          .0010
          <br />
          .0011
          <br />
          .0012
          <br />
          .0013
          <br />
          .0014
          <br />
          .0015
          <br />
          .0016
          <br />
          .0017
          <br />
          .0018
          <br />
          .0019
          <br />
          .0020
          <br />
          .0021
          <br />
          .0022
          <br />
          .0023
          <br />
          .0024
          <br />
          .0025
          <br />
          .0026
          <br />
          .0027
          <br />
          .0028
          <br />
          .0029
          <br />
          .0030
          <br />
          .0031
          <br />
          .0032
          <br />
          .0033
          <br />
          .0034
          <br />
          .0035
          <br />
          .0036
          <br />
          .0037
          <br />
          .0038
          <br />
          .0039
          <br />
          .0040
          <br />
          .0041
          <br />
          .0042
          <br />
          .0043
          <br />
          .0044
          <br />
          .0045
          <br />
          .0046
          <br />
          .0047
          <br />
          .0048
          <br />
          .0049
          <br />
          .0050
          <br />
          .0051
          <br />
          .0052
          <br />
          .0053
          <br />
          .0054
          <br />
          .0055
          <br />
          .0056
          <br />
          .0057
          <br />
          .0058
          <br />
          .0059
          <br />
          .0060
          <br />
          .0061
          <br />
          .0062
          <br />
          .0063
          <br />
          .0064
          <br />
          .0065
          <br />
          .0066
          <br />
          .0067
          <br />
          .0068
          <br />
          .0069
          <br />
          .0070
          <br />
          .0071
          <br />
          .0072
          <br />
          .0073
          <br />
          .0074
          <br />
          .0075
          <br />
          .0076
          <br />
          .0077
          <br />
          .0078
          <br />
          .0079
          <br />
          .0080
          <br />
          .0081
          <br />
          .0082
          <br />
          .0083
          <br />
          .0084
          <br />
          .0085
          <br />
          .0086
          <br />
          .0087
          <br />
          .0088
          <br />
          .0089
          <br />
          .0090
          <br />
          .0091
          <br />
          .0092
          <br />
          .0093
          <br />
          .0094
          <br />
          .0095
          <br />
          .0096
          <br />
          .0097
          <br />
          .0098
          <br />
          .0099
          <br />
          .0100
          <br />
          .0101
          <br />
          .0102
          <br />
          .0103
          <br />
          .0104
          <br />
          .0105
          <br />
          .0106
          <br />
          .0107
          <br />
          .0108
          <br />
          .0109
          <br />
          .0110
          <br />
          .0111
          <br />
          .0112
          <br />
          .0113
          <br />
          .0114
          <br />
          .0115
          <br />
          .0116
          <br />
          .0117
          <br />
          .0118
          <br />
          .0119
          <br />
          .0120
          <br />
          .0121
          <br />
          .0122
          <br />
          .0123
          <br />
          .0124
          <br />
          .0125
          <br />
          .0126
          <br />
          .0127
          <br />
          .0128
          <br />
          .0129
          <br />
          .0130
          <br />
          .0131
          <br />
          .0132
          <br />
          .0133
          <br />
          .0134
          <br />
          .0135
          <br />
          .0136
          <br />
          .0137
          <br />
          .0138
          <br />
          .0139
          <br />
          .0140
          <br />
          .0141
          <br />
          .0142
          <br />
          .0143
          <br />
          .0144
          <br />
          .0145
          <br />
          .0146
          <br />
          .0147
          <br />
          .0148
          <br />
          .0149
          <br />
          .0150
          <br />
          .0151
          <br />
          .0152
          <br />
          .0153
          <br />
          .0154
          <br />
          .0155
          <br />
          .0156
          <br />
          .0157
          <br />
          .0158
          <br />
          .0159
          <br />
          .0160
          <br />
          .0161
          <br />
          .0162
          <br />
          .0163
          <br />
          .0164
          <br />
          .0165
          <br />
          .0166
          <br />
          .0167
          <br />
          .0168
          <br />
          .0169
          <br />
          .0170
          <br />
          .0171
          <br />
          .0172
          <br />
          .0173
          <br />
          .0174
          <br />
          .0175
          <br />
          .0176
          <br />
          .0177
          <br />
          .0178
          <br />
          .0179
          <br />
          .0180
          <br />
          .0181
          <br />
          .0182
          <br />
          .0183
          <br />
          .0184
          <br />
          .0185
          <br />
          .0186
          <br />
          .0187
          <br />
          .0188
          <br />
          .0189
          <br />
          .0190
          <br />
          .0191
          <br />
          .0192
          <br />
          .0193
          <br />
          .0194
          <br />
          .0195
          <br />
          .0196
          <br />
          .0197
          <br />
          .0198
          <br />
          .0199
          <br />
          .0200
          <br />
          .0201
          <br />
          .0202
          <br />
          .0203
          <br />
          .0204
          <br />
          .0205
          <br />
          .0206
          <br />
          .0207
          <br />
          .0208
          <br />
          .0209
          <br />
          .0210
          <br />
          .0211
          <br />
          .0212
          <br />
          .0213
          <br />
          .0214
          <br />
          .0215
          <br />
          .0216
          <br />
          .0217
          <br />
          .0218
          <br />
          .0219
          <br />
          .0220
          <br />
          .0221
          <br />
          .0222
          <br />
          .0223
          <br />
          .0224
          <br />
          .0225
          <br />
          .0226
          <br />
          .0227
          <br />
          .0228
          <br />
          .0229
          <br />
          .0230
          <br />
          .0231
          <br />
          .0232
          <br />
          .0233
          <br />
          .0234
          <br />
          .0235
          <br />
          .0236
          <br />
          .0237
          <br />
          .0238
          <br />
          .0239
          <br />
          .0240
          <br />
          .0241
          <br />
          .0242
          <br />
          .0243
          <br />
          .0244
          <br />
          .0245
          <br />
          .0246
          <br />
          .0247
          <br />
          .0248
          <br />
          .0249
          <br />
          .0250
          <br />
          .0251
          <br />
          .0252
          <br />
          .0253
          <br />
          .0254
          <br />
          .0255
          <br />
          .0256
          <br />
          .0257
          <br />
          .0258
          <br />
          .0259
          <br />
          .0260
          <br />
          .0261
          <br />
          .0262
          <br />
          .0263
          <br />
          .0264
          <br />
          .0265
          <br />
          .0266
          <br />
          .0267
          <br />
          .0268
          <br />
          .0269
          <br />
          .0270
          <br />
          .0271
          <br />
          .0272
          <br />
          .0273
          <br />
          .0274
          <br />
          .0275
          <br />
          .0276
          <br />
          .0277
          <br />
          .0278
          <br />
          .0279
          <br />
          .0280
          <br />
          .0281
          <br />
          .0282
          <br />
          .0283
          <br />
          .0284
          <br />
          .0285
          <br />
          .0286
          <br />
          .0287
          <br />
          .0288
          <br />
          .0289
          <br />
          .0290
          <br />
          .0291
          <br />
          .0292
          <br />
          .0293
          <br />
          .0294
          <br />
          .0295
          <br />
          .0296
          <br />
          .0297
          <br />
          .0298
          <br />
          .0299
          <br />
          .0300
          <br />
          .0301
          <br />
          .0302
          <br />
          .0303
          <br />
          .0304
          <br />
          .0305
          <br />
          .0306
          <br />
          .0307
          <br />
          .0308
          <br />
          .0309
          <br />
          .0310
          <br />
          .0311
          <br />
          .0312
          <br />
          .0313
          <br />
          .0314
          <br />
          .0315
          <br />
          .0316
          <br />
          .0317
          <br />
          .0318
          <br />
          .0319
          <br />
          .0320
          <br />
          .0321
          <br />
          .0322
          <br />
          .0323
          <br />
          .0324
          <br />
          .0325
          <br />
          .0326
          <br />
          .0327
          <br />
          .0328
          <br />
          .0329
          <br />
          .0330
          <br />
          .0331
          <br />
          .0332
          <br />
          .0333
          <br />
          .0334
          <br />
          .0335
          <br />
          .0336
          <br />
          .0337
          <br />
          .0338
          <br />
          .0339
          <br />
          .0340
          <br />
          .0341
          <br />
          .0342
          <br />
          .0343
          <br />
          .0344
          <br />
          .0345
          <br />
          .0346
          <br />
          .0347
          <br />
          .0348
          <br />
          .0349
          <br />
          .0350
          <br />
          .0351
          <br />
          .0352
          <br />
          .0353
          <br />
          .0354
          <br />
          .0355
          <br />
          .0356
          <br />
          .0357
          <br />
          .0358
          <br />
          .0359
          <br />
          .0360
          <br />
          .0361
          <br />
          .0362
          <br />
          .0363
          <br />
          .0364
          <br />
          .0365
          <br />
          .0366
          <br />
          .0367
          <br />
          .0368
          <br />
          .0369
          <br />
          .0370
          <br />
          .0371
          <br />
          .0372
          <br />
          .0373
          <br />
          .0374
          <br />
          .0375
          <br />
          .0376
          <br />
          .0377
          <br />
          .0378
          <br />
          .0379
          <br />
          .0380
          <br />
          .0381
          <br />
          .0382
          <br />
          .0383
          <br />
          .0384
          <br />
          .0385
          <br />
          .0386
          <br />
          .0387
          <br />
          .0388
          <br />
          .0389
          <br />
          .0390
          <br />
          .0391
          <br />
          .0392
          <br />
          .0393
          <br />
          .0394
          <br />
          .0395
          <br />
          .0396
          <br />
          .0397
          <br />
          .0398
          <br />
          .0399
          <br />
          .0400
          <br />
          .0401
          <br />
          .0402
          <br />
          .0403
          <br />
          .0404
          <br />
          .0405
          <br />
          .0406
          <br />
          .0407
          <br />
          .0408
          <br />
          .0409
          <br />
          .0410
          <br />
          .0411
          <br />
          .0412
          <br />
          .0413
          <br />
          .0414
          <br />
          .0415
          <br />
          .0416
          <br />
          .0417
          <br />
          .0418
          <br />
          .0419
          <br />
          .0420
          <br />
          .0421
          <br />
          .0422
          <br />
          .0423
          <br />
          .0424
          <br />
          .0425
          <br />
          .0426
          <br />
          .0427
          <br />
          .0428
          <br />
          .0429
          <br />
          .0430
          <br />
          .0431
          <br />
          .0432
          <br />
          .0433
          <br />
          .0434
          <br />
          .0435
          <br />
          .0436
          <br />
          .0437
          <br />
          .0438
          <br />
          .0439
          <br />
          .0440
          <br />
          .0441
          <br />
          .0442
          <br />
          .0443
          <br />
          .0444
          <br />
          .0445
          <br />
          .0446
          <br />
          .0447
          <br />
          .0448
          <br />
          .0449
          <br />
          .0450
          <br />
          .0451
          <br />
          .0452
          <br />
          .0453
          <br />
          .0454
          <br />
          .0455
          <br />
          .0456
          <br />
          .0457
          <br />
          .0458
          <br />
          .0459
          <br />
          .0460
          <br />
          .0461
          <br />
          .0462
          <br />
          .0463
          <br />
          .0464
          <br />
          .0465
          <br />
          .0466
          <br />
          .0467
          <br />
          .0468
          <br />
          .0469
          <br />
          .0470
          <br />
          .0471
          <br />
          .0472
          <br />
          .0473
          <br />
          .0474
          <br />
          .0475
          <br />
          .0476
          <br />
          .0477
          <br />
          .0478
          <br />
          .0479
          <br />
          .0480
          <br />
          .0481
          <br />
          .0482
          <br />
          .0483
          <br />
          .0484
          <br />
          .0485
          <br />
          .0486
          <br />
          .0487
          <br />
          .0488
          <br />
          .0489
          <br />
          .0490
          <br />
          .0491
          <br />
          .0492
          <br />
          .0493
          <br />
          .0494
          <br />
          .0495
          <br />
          .0496
          <br />
          .0497
          <br />
          .0498
          <br />
          .0499
          <br />
          .0500
          <br />
          .0501
          <br />
          .0502
          <br />
          .0503
          <br />
          .0504
          <br />
          .0505
          <br />
          .0506
          <br />
          .0507
          <br />
          .0508
          <br />
          .0509
          <br />
          .0510
          <br />
          .0511
          <br />
          .0512
          <br />
          .0513
          <br />
          .0514
          <br />
          .0515
          <br />
          .0516
          <br />
          .0517
          <br />
          .0518
          <br />
          .0519
          <br />
          .0520
          <br />
          .0521
          <br />
          .0522
          <br />
          .0523
          <br />
          .0524
          <br />
          .0525
          <br />
          .0526
          <br />
          .0527
          <br />
          .0528
          <br />
          .0529
          <br />
          .0530
          <br />
          .0531
          <br />
          .0532
          <br />
          .0533
          <br />
          .0534
          <br />
          .0535
          <br />
          .0536
          <br />
          .0537
          <br />
          .0538
          <br />
          .0539
          <br />
          .0540
          <br />
          .0541
          <br />
          .0542
          <br />
          .0543
          <br />
          .0544
          <br />
          .0545
          <br />
          .0546
          <br />
          .0547
          <br />
          .0548
          <br />
          .0549
          <br />
          .0550
          <br />
          .0551
          <br />
          .0552
          <br />
          .0553
          <br />
          .0554
          <br />
          .0555
          <br />
          .0556
          <br />
          .0557
          <br />
          .0558
          <br />
          .0559
          <br />
          .0560
          <br />
          .0561
          <br />
          .0562
          <br />
          .0563
          <br />
          .0564
          <br />
          .0565
          <br />
          .0566
          <br />
          .0567
          <br />
          .0568
          <br />
          .0569
          <br />
          .0570
          <br />
          .0571
          <br />
          .0572
          <br />
          .0573
          <br />
          .0574
          <br />
          .0575
          <br />
          .0576
          <br />
          .0577
          <br />
          .0578
          <br />
          .0579
          <br />
          .0580
          <br />
          .0581
          <br />
          .0582
          <br />
          .0583
          <br />
          .0584
          <br />
          .0585
          <br />
          .0586
          <br />
          .0587
          <br />
          .0588
          <br />
          .0589
          <br />
          .0590
          <br />
          .0591
          <br />
          .0592
          <br />
          .0593
          <br />
          .0594
          <br />
          .0595
          <br />
          .0596
          <br />
          .0597
          <br />
          .0598
          <br />
          .0599
          <br />
          .0600
          <br />
          .0601
          <br />
          .0602
          <br />
          .0603
          <br />
          .0604
          <br />
          .0605
          <br />
          .0606
          <br />
          .0607
          <br />
          .0608
          <br />
          .0609
          <br />
          .0610
          <br />
          .0611
          <br />
          .0612
          <br />
          .0613
          <br />
          .0614
          <br />
          .0615
          <br />
          .0616
          <br />
          .0617
          <br />
          .0618
          <br />
          .0619
          <br />
          .0620
          <br />
          .0621
          <br />
          .0622
          <br />
          .0623
          <br />
          .0624
          <br />
          .0625
          <br />
          .0626
          <br />
          .0627
          <br />
          .0628
          <br />
          .0629
          <br />
          .0630
          <br />
          .0631
          <br />
          .0632
          <br />
          .0633
          <br />
          .0634
          <br />
          .0635
          <br />
          .0636
          <br />
          .0637
          <br />
          .0638
          <br />
          .0639
          <br />
          .0640
          <br />
          .0641
          <br />
          .0642
          <br />
          .0643
          <br />
          .0644
          <br />
          .0645
          <br />
          .0646
          <br />
          .0647
          <br />
          .0648
          <br />
          .0649
          <br />
          .0650
          <br />
          .0651
          <br />
          .0652
          <br />
          .0653
          <br />
          .0654
          <br />
          .0655
          <br />
          .0656
          <br />
          .0657
          <br />
          .0658
          <br />
          .0659
          <br />
          .0660
          <br />
          .0661
          <br />
          .0662
          <br />
          .0663
          <br />
          .0664
          <br />
          .0665
          <br />
          .0666
          <br />
          .0667
          <br />
          .0668
          <br />
          .0669
          <br />
          .0670
          <br />
          .0671
          <br />
          .0672
          <br />
          .0673
          <br />
          .0674
          <br />
          .0675
          <br />
          .0676
          <br />
          .0677
          <br />
          .0678
          <br />
          .0679
          <br />
          .0680
          <br />
          .0681
          <br />
          .0682
          <br />
          .0683
          <br />
          .0684
          <br />
          .0685
          <br />
          .0686
          <br />
          .0687
          <br />
          .0688
          <br />
          .0689
          <br />
          .0690
          <br />
          .0691
          <br />
          .0692
          <br />
          .0693
          <br />
          .0694
          <br />
          .0695
          <br />
          .0696
          <br />
          .0697
          <br />
          .0698
          <br />
          .0699
          <br />
          .0700
          <br />
          .0701
          <br />
          .0702
          <br />
          .0703
          <br />
          .0704
          <br />
          .0705
          <br />
          .0706
          <br />
          .0707
          <br />
          .0708
          <br />
          .0709
          <br />
          .0710
          <br />
          .0711
          <br />
          .0712
          <br />
          .0713
          <br />
          .0714
          <br />
          .0715
          <br />
          .0716
          <br />
          .0717
          <br />
          .0718
          <br />
          .0719
          <br />
          .0720
          <br />
          .0721
          <br />
          .0722
          <br />
          .0723
          <br />
          .0724
          <br />
          .0725
          <br />
          .0726
          <br />
          .0727
          <br />
          .0728
          <br />
          .0729
          <br />
          .0730
          <br />
          .0731
          <br />
          .0732
          <br />
          .0733
          <br />
          .0734
          <br />
          .0735
          <br />
          .0736
          <br />
          .0737
          <br />
          .0738
          <br />
          .0739
          <br />
          .0740
          <br />
          .0741
          <br />
          .0742
          <br />
          .0743
          <br />
          .0744
          <br />
          .0745
          <br />
          .0746
          <br />
          .0747
          <br />
          .0748
          <br />
          .0749
          <br />
          .0750
          <br />
          .0751
          <br />
          .0752
          <br />
          .0753
          <br />
          .0754
          <br />
          .0755
          <br />
          .0756
          <br />
          .0757
          <br />
          .0758
          <br />
          .0759
          <br />
          .0760
          <br />
          .0761
          <br />
          .0762
          <br />
          .0763
          <br />
          .0764
          <br />
          .0765
          <br />
          .0766
          <br />
          .0767
          <br />
          .0768
          <br />
          .0769
          <br />
          .0770
          <br />
          .0771
          <br />
          .0772
          <br />
          .0773
          <br />
          .0774
          <br />
          .0775
          <br />
          .0776
          <br />
          .0777
          <br />
          .0778
          <br />
          .0779
          <br />
          .0780
          <br />
          .0781
          <br />
          .0782
          <br />
          .0783
          <br />
          .0784
          <br />
          .0785
          <br />
          .0786
          <br />
          .0787
          <br />
          .0788
          <br />
          .0789
          <br />
          .0790
          <br />
          .0791
          <br />
          .0792
          <br />
          .0793
          <br />
          .0794
          <br />
          .0795
          <br />
          .0796
          <br />
          .0797
          <br />
          .0798
          <br />
          .0799
          <br />
          .0800
          <br />
          .0801
          <br />
          .0802
          <br />
          .0803
          <br />
          .0804
          <br />
          .0805
          <br />
          .0806
          <br />
          .0807
          <br />
          .0808
          <br />
          .0809
          <br />
          .0810
          <br />
          .0811
          <br />
          .0812
          <br />
          .0813
          <br />
          .0814
          <br />
          .0815
          <br />
          .0816
          <br />
          .0817
          <br />
          .0818
          <br />
          .0819
          <br />
          .0820
          <br />
          .0821
          <br />
          .0822
          <br />
          .0823
          <br />
          .0824
          <br />
          .0825
          <br />
          .0826
          <br />
          .0827
          <br />
          .0828
          <br />
          .0829
          <br />
          .0830
          <br />
          .0831
          <br />
          .0832
          <br />
          .0833
          <br />
          .0834
          <br />
          .0835
          <br />
          .0836
          <br />
          .0837
          <br />
          .0838
          <br />
          .0839
          <br />
          .0840
          <br />
          .0841
          <br />
          .0842
          <br />
          .0843
          <br />
          .0844
          <br />
          .0845
          <br />
          .0846
          <br />
          .0847
          <br />
          .0848
          <br />
          .0849
          <br />
          .0850
          <br />
          .0851
          <br />
          .0852
          <br />
          .0853
          <br />
          .0854
          <br />
          .0855
          <br />
          .0856
          <br />
          .0857
          <br />
          .0858
          <br />
          .0859
          <br />
          .0860
          <br />
          .0861
          <br />
          .0862
          <br />
          .0863
          <br />
          .0864
          <br />
          .0865
          <br />
          .0866
          <br />
          .0867
          <br />
          .0868
          <br />
          .0869
          <br />
          .0870
          <br />
          .0871
          <br />
          .0872
          <br />
          .0873
          <br />
          .0874
          <br />
          .0875
          <br />
          .0876
          <br />
          .0877
          <br />
          .0878
          <br />
          .0879
          <br />
          .0880
          <br />
          .0881
          <br />
          .0882
          <br />
          .0883
          <br />
          .0884
          <br />
          .0885
          <br />
          .0886
          <br />
          .0887
          <br />
          .0888
          <br />
          .0889
          <br />
          .0890
          <br />
          .0891
          <br />
          .0892
          <br />
          .0893
          <br />
          .0894
          <br />
          .0895
          <br />
          .0896
          <br />
          .0897
          <br />
          .0898
          <br />
          .0899
          <br />
          .0900
          <br />
          .0901
          <br />
          .0902
          <br />
          .0903
          <br />
          .0904
          <br />
          .0905
          <br />
          .0906
          <br />
          .0907
          <br />
          .0908
          <br />
          .0909
          <br />
          .0910
          <br />
          .0911
          <br />
          .0912
          <br />
          .0913
          <br />
          .0914
          <br />
          .0915
          <br />
          .0916
          <br />
          .0917
          <br />
          .0918
          <br />
          .0919
          <br />
          .0920
          <br />
          .0921
          <br />
          .0922
          <br />
          .0923
          <br />
          .0924
          <br />
          .0925
          <br />
          .0926
          <br />
          .0927
          <br />
          .0928
          <br />
          .0929
          <br />
          .0930
          <br />
          .0931
          <br />
          .0932
          <br />
          .0933
          <br />
          .0934
          <br />
          .0935
          <br />
          .0936
          <br />
          .0937
          <br />
          .0938
          <br />
          .0939
          <br />
          .0940
          <br />
          .0941
          <br />
          .0942
          <br />
          .0943
          <br />
          .0944
          <br />
          .0945
          <br />
          .0946
          <br />
          .0947
          <br />
          .0948
          <br />
          .0949
          <br />
          .0950
          <br />
          .0951
          <br />
          .0952
          <br />
          .0953
          <br />
          .0954
          <br />
          .0955
          <br />
          .0956
          <br />
          .0957
          <br />
          .0958
          <br />
          .0959
          <br />
          .0960
          <br />
          .0961
          <br />
          .0962
          <br />
          .0963
          <br />
          .0964
          <br />
          .0965
          <br />
          .0966
          <br />
          .0967
          <br />
          .0968
          <br />
          .0969
          <br />
          .0970
          <br />
          .0971
          <br />
          .0972
          <br />
          .0973
          <br />
          .0974
          <br />
          .0975
          <br />
          .0976
          <br />
          .0977
          <br />
          .0978
          <br />
          .0979
          <br />
          .0980
          <br />
          .0981
          <br />
          .0982
          <br />
          .0983
          <br />
          .0984
          <br />
          .0985
          <br />
          .0986
          <br />
          .0987
          <br />
          .0988
          <br />
          .0989
          <br />
          .0990
          <br />
          .0991
          <br />
          .0992
          <br />
          .0993
          <br />
          .0994
          <br />
          .0995
          <br />
          .0996
          <br />
          .0997
          <br />
          .0998
          <br />
          .0999
          <br />
          .0999
          <br />
          .0999
          <br />
          .0999
          <br />
          .1000
          <br />
          .1000
          <br />
          .1000
          <br />
          .1000
          <br />
          .1000
          <br />
          .1000
          <br />
          .1000
          <br />
          .1000
          <br />
          .1000
        </div>
      </div>
    </div>
  );
};

export default Intro;
